import jQuery from "jquery";
import bootstrap from "bootstrap"
import "lightgallery";
import "lg-zoom";
import "lg-thumbnail";


jQuery(function () {
    const $ = jQuery;
    window.$ = jQuery;

    $('div.gallery-images').lightGallery({
        thumbnail:true,
        animateThumb: false,
        showThumbByDefault: false
    });
});
